import './styles/KeyBoard.css';

const KeyBoard = () => {
    return <div class="keyboard">
        <div class="row">
            <div class="key function-key">esc</div>
            <div class="key function-key">F1</div>
            <div class="key function-key">F2</div>
            <div class="key function-key">F3</div>
            <div class="key function-key">F4</div>
            <div class="key function-key">F5</div>
            <div class="key function-key">F6</div>
            <div class="key function-key">F7</div>
            <div class="key function-key">F8</div>
            <div class="key function-key">F9</div>
            <div class="key function-key">F10</div>
            <div class="key function-key">F11</div>
            <div class="key function-key">F12</div>
            <div class="key eject-key">⏏</div>
        </div>

        <div class="row">
            <div class="key">`</div>
            <div class="key">1</div>
            <div class="key">2</div>
            <div class="key">3</div>
            <div class="key">4</div>
            <div class="key">5</div>
            <div class="key">6</div>
            <div class="key">7</div>
            <div class="key">8</div>
            <div class="key">9</div>
            <div class="key">0</div>
            <div class="key">-</div>
            <div class="key">=</div>
            <div class="key delete-key">delete</div>
        </div>

        <div class="row">
            <div class="key tab-key">tab</div>
            <div class="key">Q</div>
            <div class="key">W</div>
            <div class="key">E</div>
            <div class="key">R</div>
            <div class="key">T</div>
            <div class="key">Y</div>
            <div class="key">U</div>
            <div class="key">I</div>
            <div class="key">O</div>
            <div class="key">P</div>
            <div class="key">[</div>
            <div class="key">]</div>
            <div class="key backslash-key">\</div>
        </div>

        <div class="row">
            <div class="key caps-lock-key">caps lock</div>
            <div class="key">A</div>
            <div class="key">S</div>
            <div class="key">D</div>
            <div class="key">F</div>
            <div class="key">G</div>
            <div class="key">H</div>
            <div class="key">J</div>
            <div class="key">K</div>
            <div class="key">L</div>
            <div class="key">;</div>
            <div class="key">'</div>
            <div class="key return-key">return</div>
        </div>

        <div class="row">
            <div class="key shift-key">shift</div>
            <div class="key">Z</div>
            <div class="key">X</div>
            <div class="key">C</div>
            <div class="key">V</div>
            <div class="key">B</div>
            <div class="key">N</div>
            <div class="key">M</div>
            <div class="key">,</div>
            <div class="key">.</div>
            <div class="key">/</div>
            <div class="key shift-key">shift</div>
        </div>

        <div class="row">
            <div class="key">fn</div>
            <div class="key ctrl-key">ctrl</div>
            <div class="key alt-key">⌥</div>
            <div class="key command-key">⌘</div>
            <div class="key space-key"></div>
            <div class="key command-key">⌘</div>
            <div class="key alt-key">⌥</div>
            <div class="key arrow-key">◀</div>
            <div class="key arrow-key">▼</div>
            <div class="key arrow-key">▲</div>
            <div class="key arrow-key">▶</div>
        </div>
    </div>
}

export default KeyBoard;

export const Sponsor = () => {
  return (
    <div className="btn-container animate-bounce font-jarkarta">
      <div className="btn-drawer transition-bottom">Donate</div>
      <a href="https://buymeacoffee.com/shafishaik" target="_blank" rel="noopener noreferrer">
        <button className="btn">
          <span className="btn-text text-xs sm:text-xs md:text-xs">
            Sponsor this website
          </span>
        </button>
      </a>
    </div>
  );
};
